<template>
    <div>
        <div class="bg-white margin-bottom flex">
<!--            <div class="tj-num flex align-center flex-wrap">-->
<!--                <div class="ban" v-for="(item,index) in total.header" :key="index"><span>{{ item.name }}:{{ item.num }} <b>次</b></span>-->
<!--                </div>-->
<!--            </div>-->
            <div class=" flex flex-direction">
                <div class="total-container margin-bottom-sm">总计：<span>{{total.total}}</span></div>
                <div class="tj-num flex align-center justify-between" v-for="(item,index) in total.header" :key="index">
                    <div class="flex align-center">
                        <img class="icon" :src="item.icon">
                        <div class="label">{{ item.name }}</div>
                    </div>
                    <div class="number">{{ item.num }} <span>次</span></div>
                </div>
            </div>
            <div class="charts-container flex flex-direction flex-sub margin-left">
                <div class="tip-container flex align-center justify-between">
                    <div class="title">小区服务统计情况</div>
                    <div class="classify">服务次数</div>
                </div>
                <div class="echart" id="total"></div>
            </div>
        </div>
        <div class="bg-white">
            <div class="flex align-center  margin-bottom">
                <h3 class="">各小区服务统计</h3>
                <el-select class="margin-left-sm" v-model="xiangmuId" placeholder="请选择社区" @change="getTj" v-if="[3].includes(user.power)">
                    <el-option
                        v-for="item in projectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-button class="margin-left-sm" type="primary" @click="exportData" :loading="export_loading">导出</el-button>
            </div>
            <div class="flex align-center justify-between flex-wrap ">
                <div class="xiaoqu-item" v-for="item in total.xiaoqu" :key="item.id">
                    <div class="flex align-center justify-between">
                        <div class="flex-sub">
                            <h4 class="xq-name">{{ item.name }}</h4>
                            <div class="flex align-center flex-wrap">
                                <div class="server-num flex align-center" v-for="(cate,pos) in item.cate" :key="pos">
                                    <!--                                    <img src="../../assets/img/huan1.png" alt="" class="margin-right-xsm">-->
                                    {{ cate.name }}/<span>{{ cate.num }}</span>次
                                </div>
                            </div>
                        </div>
                        <div class="flex align-center justify-between xq-now">
                            <div class="flex align-center justify-around"><p><span>{{ item.xiaoqu_apply_num }}</span>申请服务
                            </p>
                            </div>
                            <div class="flex align-center justify-around"><p><span>{{ item.xiaoqu_handle_num }}</span>处理中
                            </p></div>
                        </div>
                    </div>
                    <div class="flex align-center justify-between pingjia">
                        <div>非常满意<span></span>{{ item.xiaoqu_fcmy_num }}</div>
                        <div>满意<span></span>{{ item.xiaoqu_my_num }}</div>
                        <div>一般<span></span>{{ item.xiaoqu_yb_num }}</div>
                        <div>不满意<span></span>{{ item.xiaoqu_bmy_num }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {exportJuminService, getNewJuminService} from "@/api/weilao";
import {getXiangMuList} from "@/api/common";
import {downloadFile} from "@/utils/utils";
import * as echarts from 'echarts'
export default {
    name: "server-tj",
    data() {
        return {
            xiangmuId: '',
            total: {
                header: [],
                total: 0,
                xiaoqu: [],
                projectList: [],
            },
            total_options:{
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                tooltip: {
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                series:  {
                    data: [120, 200, 150, 80, 70, 110, 130],
                    type: 'bar',
                    barMaxWidth: 50,
                    itemStyle: {
                        color: '#5aaef3'
                    }
                }
            },
            export_loading:false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        server() {
            return this.$store.state.server
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "双暖为老", false);
        this.getXiaoQuList()
        this.getTj()
    },
    components: {},
    methods: {
        //  获取当前人员下的小区
        async getXiaoQuList() {
            const project = await getXiangMuList()
            project.data.unshift({
                id:'',
                name:'全部'
            })
            this.projectList = project.data
        },
        async getTj() {
            let _data = await getNewJuminService(this.xiangmuId)
            this.total = _data.data
            let total_chart = echarts.init(document.getElementById('total'))
            this.total_options.xAxis.data = _data.data.header.map(item=>{ return item.name})
            this.total_options.series.data = _data.data.header.map(item=>{ return item.num})
            total_chart.setOption(this.total_options)
            window.onresize = total_chart.resize
        },
        async exportData() {
            this.export_loading = true
            let _data = await exportJuminService()
            this.export_loading = false
            downloadFile(_data.data,'社区服务数据.xls');
        },

    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.tj-num {
    width: 320px;
    height: 56px;
    background-color: #edf2f6;
    margin-top: 10px;
    padding: 0 25px;
    .icon{
        width: 28px;
        height: 28px;
    }
    .label{
        font-size: 16px;
        color: #333333;
        margin-left: 15px;
    }
    .number{
        font-size: 16px;
        color: #333333;
        span{
            color: #f59508;
        }
    }
}

.total-container{
    width: 320px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    span{
        font-size: 28px;
        color: #f59508;
    }
}

.charts-container{
    height: 565px;
    background-color: #ffffff;
    border-radius: 10px;
    border: solid 1px #e5e5e5;
    padding: 20px;
    .tip-container{
        height: 60px;
        background-color: #f5f6f8;
        border-radius: 10px;
        padding: 0 20px;
        .title{
            font-size: 20px;
            font-weight: 600;
            color: #333333;
        }
        .classify{
            font-size: 16px;
            color: #333333;
            position: relative;
            &:after{
                content: '';
                position: absolute;
                width: 12px;
                height: 12px;
                background-color: #5aaef3;
                left: -20px;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
    .echart{
        width: 100%;
        height: 424px;
        margin-top: 20px;
    }
}

.xiaoqu-item {
    width: 48%;
    height: 198px;
    padding: 20px;
    background-color: #ffffff;
    box-shadow: 0px 0px 29px 0px rgba(143, 143, 143, 0.22);
    border-radius: 10px;

    .xq-name {
        line-height: 40px;
        font-size: 22px;
    }

    .server-num {
        font-size: 14px;
        margin-right: 10px;

        span {
            color: #f3b861;
        }
    }

    .xq-now {
        div {
            width: 88px;
            height: 88px;
            background-color: rgba(#f3b861, .1);
            border-radius: 5px;
            margin-left: 15px;
            line-height: 26px;

            span {
                display: block;
                text-align: center;
                font-size: 22px;
                color: #f3b861;
            }
        }
    }

    .pingjia {
        margin-top: 15px;

        div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 24%;
            height: 40px;
            padding: 0 10px;
            border-radius: 5px;
            border: solid 1px #fbe7e7;

            span {
                padding: 0 5px;
            }
        }
    }
}
</style>





